import React from "react";
import { Box, LinearProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  colorPrimary: {
    background: theme.palette.primary.main,
  },
  barColorPrimary: {
    background: theme.palette.secondary.main,
  },
}));

export default function LoadingBar({ loading }) {
  const classes = useStyles();

  return (
    <>
      {loading ? (
        <Box sx={{ width: "100%" }}>
          <LinearProgress
            classes={{
              colorPrimary: classes.colorPrimary,
              barColorPrimary: classes.barColorPrimary,
            }}
          />
        </Box>
      ) : null}
    </>
  );
}
